































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { Component, Vue, Emit } from 'vue-property-decorator';
import { spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { CollapseTransition },
  mixins: [TableStripe],
})
export default class CompanyIndex extends Vue {
  formShow = false; // 查询表单是否显示
  // 表单数据对象
  formData: object = {
    code: undefined, // 公司代码
    name: undefined, // 公司名称
    enabled: undefined, // 状态
  };
  // table表格循环项
  tableOptions: any[] = [
    { label: '公司名称', prop: 'name' },
    { label: '排序号', prop: 'sort' },
    { label: '状态', prop: 'enabled' },
  ];
  // table表格数据对象
  tableData: any[] = [];
  rowId = '';
  // Vue 数据创建生命周期钩子函数
  created() {
    // 初始化所有空间数据
    this.getAllData({});
  }

  /**
   * @desc 获取空间所有数据
   * @param1 data：用来筛选数据的条件对象
   * @returns 暂无
   */
  getAllData(data: any) {
    spaceServe
      .getAllData(data)
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('初始化空间数据失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: boolean): string => {
      if (state) {
        return 'tag-green';
      } else {
        return 'tag-red';
      }
    };
  }

  /**
   * @desc 状态的计算属性，如果状态是 true: 正常  false：停用
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  get setUserState(): object {
    return (state: number): string => {
      if (state) {
        return '正常';
      } else {
        return '停用';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮，切换搜索表单显示状态。
   * @param1 暂无
   * @returns 暂无
   */
  setFormShow() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件数据。
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.getAllData(this.formData); // 查询符合条件的数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields(); // 重置表单
    this.getAllData({}); // 重置所有数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击编辑图标触发，跳转到编辑页面。
   * @param1 row: 要编辑的这一行的数据对象
   * @returns 暂无
   */
  @Emit('getRow')
  editCompany(row: string, rowId: string) {
    this.rowId = rowId; // 将该行 id 传递到编辑页面
    this.$emit('update:showFlag', 2); // 跳转到编辑公司页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击加图标触发，进入添加下级公司界面.
   * @param1 row：是该行数据 id
   * @returns 返回值描述
   */
  @Emit('getRow')
  addNextCompany(row: string) {
    this.$emit('update:showFlag', 3); // 跳转到新增下级页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击新增按钮，跳转到新增公司界面。
   * @param1 暂无
   * @returns 暂无
   */
  addCompany() {
    this.$emit('update:showFlag', 4); // 跳转到新增页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击展开或折叠按钮触发，展开或折叠 table 树状图
   * @param1 暂无
   * @returns 暂无
   */
  toggleTableTree(flag: boolean) {
    // 展开或折叠所有 table
    this.forArr(this.tableData, flag);
  }

  /**
   * @desc 递归函数，展开全部 table 内容
   * @param1 data：需要循环的数据
   * @param2 flag：判断展开还是折叠
   * @returns 暂无
   */
  forArr(data: any[], flag: boolean) {
    data.forEach(item => {
      (this.$refs.tableRef as any).toggleRowExpansion(item, flag);
      if (item.children) {
        this.forArr(item.children, flag);
      }
    });
  }

  /**
   * @desc 点击停用公司按钮触发, 停用公司
   * @param1 id：需要停用的用户id
   * @returns 暂无
   */
  stopCompany(row: any) {
    this.$confirm(`确认要${row.enabled ? '停用' : '启用'}该空间吗？`, '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        spaceServe
          .editData({ id: row.id, enabled: !row.enabled })
          .then((res: any) => {
            if (res.code == '200') {
              this.$message.success(`${row.enabled ? '停用' : '启用'}成功!`);
              // 刷新数据
              this.getAllData({});
            }
          })
          .catch(() => {
            this.$message.error(`${row.enabled ? '停用' : '启用'}失败,请稍后重试!`);
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: `已取消${row.enabled ? '停用' : '启用'}`,
        });
      });
  }

  /**
   * @desc 点击删除公司触发，删除改行公司
   * @param1 id：要删除的公司的id
   * @returns 暂无
   */
  deleteCompany(id: string) {
    this.$confirm('确认要删除该空间吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        // 删除空间
        spaceServe
          .deleteData(id)
          .then((res: any) => {
            if (res.code == '200') {
              this.$message.success('删除成功!');
              // 刷新数据
              this.getAllData({});
            }
          })
          .catch(() => {
            this.$message.error('删除失败,请稍后重试！');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
}
